
import { Component } from 'vue-property-decorator';
import SignupForm from '@/components/signup/SignupForm.vue';
import { SignupFormData } from '@/model/Signup';
import { mapActions, mapGetters } from 'vuex';
import { mixins } from 'vue-class-component';
import ToastMixin from '@/mixins/ToastMixin';
import ToastVariant from '@/model/enums/toast/toast-variant';
import Selector from '@/components/language/Selector.vue';
import SignupResetPasswordLayout from '@/components/layout/SignupResetPasswordLayout.vue';

@Component({
    components: {
        SignupForm,
        Selector,
        SignupResetPasswordLayout,
    },
    computed: {
        ...mapGetters({
            signupError: 'signupStorage/getError',
        }),
    },

    methods: {
        ...mapActions({
            signup: 'signupStorage/signup',
        }),
    },
})
export default class Signup extends mixins(ToastMixin) {
    loading = false;

    signup!: (formData: SignupFormData) => Promise<void>;

    mounted(): void {
        this.$store.commit('signupStorage/setError', null);
    }

    onSubmit(formData: SignupFormData): void {
        this.loading = true;
        this.signup(formData)
            .then(() => {
                this.$router.push({ name: 'Dashboard' }).then(() => {
                    this.$nextTick(() => {
                        this.showToast(
                            this.$t(
                                'signup.notification.successful',
                            ).toString(),
                            this.$t('signup.notification.title').toString(),
                            ToastVariant.SUCCESS,
                        );
                    });
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
